import { api, API } from "@/lib/api";

const SID = "rs_simran_chat_session";
export const chatSession = () => {
  let s = localStorage.getItem(SID);
  if (!s) { s = `${Date.now()}${Math.random().toString(16).slice(2)}`; localStorage.setItem(SID, s); }
  return s;
};

const HIDE = ["/admin", "/teacher", "/principal", "/student", "/virtual-classroom", "/simran-live", "/courses/aiot-diploma/", "/verify"];
// The floating "Ask Simran Ma'am" button lives only on her lecture pages; elsewhere the chat opens only from in-page buttons.
export const onSimranLecture = (path) => path === "/" || path.startsWith("/simran-live") || path.startsWith("/courses/aiot-diploma/learn");
export const chatVisible = (path) => onSimranLecture(path) || !HIDE.some((p) => path.startsWith(p)) || path === "/student/login";

export const sectionFor = (path) => {
  if (path.startsWith("/courses/aiot-diploma")) return "aiot";
  if (path.startsWith("/enroll")) return "enroll";
  if (path.startsWith("/student/login")) return "admissions";
  if (path.startsWith("/schools")) return "schools";
  if (path.startsWith("/learn-and-earn")) return "learn_earn";
  if (["/contact", "/track-order", "/roboshop"].some((p) => path.startsWith(p))) return "support";
  return "general";
};

export const STARTERS = {
  general: [["Which course suits Class 8?", "क्लास 8 के लिए कौन सा कोर्स सही है?"], ["What is Learn & Earn?", "लर्न एंड अर्न क्या है?"], ["How do I enroll?", "दाखिला कैसे लूँ?"]],
  aiot: [["Who can join the AIoT Diploma?", "AIoT डिप्लोमा कौन कर सकता है?"], ["How is the result calculated?", "रिज़ल्ट कैसे बनता है?"], ["How do I apply?", "आवेदन कैसे करूँ?"]],
  enroll: [["Which plan should I choose?", "कौन सा प्लान चुनूँ?"], ["What does the form need?", "फ़ॉर्म में क्या चाहिए?"], ["When do classes start?", "क्लास कब शुरू होंगी?"]],
  admissions: [["How do I fill the admission form?", "एडमिशन फ़ॉर्म कैसे भरूँ?"], ["How do I get my student ID?", "स्टूडेंट ID कैसे मिलेगी?"], ["I can't log in", "लॉगिन नहीं हो रहा"]],
  schools: [["What does a school lab include?", "स्कूल लैब में क्या मिलता है?"], ["Is it NEP aligned?", "क्या यह NEP के अनुसार है?"], ["How do we partner?", "पार्टनर कैसे बनें?"]],
  learn_earn: [["How do students earn?", "छात्र कैसे कमाते हैं?"], ["Which products are sold?", "कौन से प्रोडक्ट बिकते हैं?"], ["Which plan has Learn & Earn?", "किस प्लान में लर्न एंड अर्न है?"]],
  support: [["Track my Roboshop order", "मेरा ऑर्डर ट्रैक करें"], ["I need help with a payment", "पेमेंट में मदद चाहिए"], ["How do I contact the team?", "टीम से कैसे संपर्क करूँ?"]],
  faq: [["Do I need hardware for the diploma?", "क्या डिप्लोमा के लिए हार्डवेयर चाहिए?"], ["Is a job guaranteed?", "क्या नौकरी की गारंटी है?"], ["How do I get access after applying?", "आवेदन के बाद एक्सेस कैसे मिलेगा?"]],
};

export const chatHistory = () => api.get(`/simran/history/${chatSession()}`).then((r) => r.data.items).catch(() => []);
export const sendLead = (body) => api.post("/simran/lead", { session_id: chatSession(), ...body }).then((r) => r.data);

// Streams Simran's reply; onText gets the growing text, onMeta gets {unsure} right after the answer and {suggest} a moment later.
export async function streamChat(body, onText, onMeta) {
  const res = await fetch(`${API}/simran/chat`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ session_id: chatSession(), ...body }) });
  if (res.status === 429) throw new Error("busy");
  if (!res.ok || !res.body) throw new Error("failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "", text = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      const line = ev.trim();
      if (!line.startsWith("data:")) continue;
      const d = JSON.parse(line.slice(5));
      if (d.error) throw new Error("failed");
      if (d.t) { text += d.t; onText(text); }
      if ("unsure" in d || d.suggest) onMeta(d);
    }
  }
  return text.trim();
}

export const openSimran = (question, section) => window.dispatchEvent(new CustomEvent("simran:open", { detail: { question, section } }));
